import React from "react";
import "../style/Footer.css";
import logo from "../img/quanto_light.png";
import EmailIcon from "@mui/icons-material/Email";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import YoutubeIcon from "@mui/icons-material/YouTube";
import { Link } from "react-router-dom";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function Footer() {
  const whatsappNumber = "+917904159558";

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-left">
          <Link to={`mailto:support@quantoretail.com`} className="footer-email">
            <span className="material-icons">
              <EmailIcon />
            </span>
            support@quantoretail.com
          </Link>
          <div className="footer-logo">
            <img src={logo} alt="Quanto Logo" className="logo-img" />
          </div>
          <p className="footer-description">
            Quanto is a solution of a strong retail team & collaborative
            brain-child of retail industry experts, retail giants, employees &
            key stakeholders who has shared 30 years of retail specific
            experience & wisdom for designing the feature rich software.
          </p>
        </div>
        <div className="footer-right">
          <div className="footer-links">
            <div className="footer-column">
              <h4>QUICK LINKS</h4>
              <Link to="/">Home</Link>
              <Link to="/features">Features</Link>
              <Link to="/unlock-profit">Unlock Profit</Link>
              <Link to="/clients-trust">Clients Trust</Link>
              <Link to="/pricing">Pricing</Link>
              <Link to="/get-demo">Contact Us</Link>
            </div>
            <div className="footer-column">
              <h4>COMPANY</h4>
              <Link to="/about">About Us</Link>
              <Link to="/why-quanto">Why Quanto?</Link>
              <Link to="http://blog.quantoretail.com/">Blog</Link>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </div>
          </div>
          <div className="footer-social">
            <h4>Follow Us On</h4>
            <div>
              <Link to="/">
                <span className="material-icons">
                  <FacebookIcon />
                </span>
              </Link>
              <Link to="/">
                <span className="material-icons">
                  <LinkedInIcon />
                </span>
              </Link>
              <Link to="/">
                <span className="material-icons">
                  <InstagramIcon />
                </span>
              </Link>
              <Link to="/">
                <span className="material-icons">
                  <YoutubeIcon />
                </span>
              </Link>
            </div>
            <div style={{ display: "flex", gap: 20 }}>
              <div style={{ marginTop: 20 }}>
                <h3 style={{ textAlign: "center" }}>For Support</h3>
                <a
                  href={`https://wa.me/+919384030115`}
                  className="whatsapp-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsAppIcon style={{ fontSize: "2em" }} />
                  <span>+91 9384030115</span>
                </a>
                <a
                  href={`https://wa.me/+919384030116`}
                  className="whatsapp-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsAppIcon style={{ fontSize: "2em" }} />
                  <span>+91 9384030116</span>
                </a>
                <a
                  href={`https://wa.me/+919384030117`}
                  className="whatsapp-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsAppIcon style={{ fontSize: "2em" }} />
                  <span>+91 9384030117</span>
                </a>
              </div>
              <div style={{ marginTop: 20 }}>
                <h3 style={{ textAlign: "center" }}>For Sales</h3>
                <a
                  href={`https://wa.me/+919384030113`}
                  className="whatsapp-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsAppIcon style={{ fontSize: "2em" }} />
                  <span>+91 9384030113</span>
                </a>
                <a
                  href={`https://wa.me/+918667875166`}
                  className="whatsapp-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsAppIcon style={{ fontSize: "2em" }} />
                  <span>+91 8667875166</span>
                </a>
                <a
                  href={`https://wa.me/+917904159558`}
                  className="whatsapp-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <WhatsAppIcon style={{ fontSize: "2em" }} />
                  <span>+91 7904159558</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>Quanto Retail &copy; 2025 All Rights Reserved. </p>
        <p>
          {" "}
          Website Designed By{" "}
          <Link
            to="https://abienterprises.co/"
            target="_blank"
            rel="noreferrer"
          >
            Abi Enterprises
          </Link>
        </p>
      </div>
    </footer>
  );
}
